/**
 * Decides whether Tracker.initialize() should set the anonymous identity
 * (`setUserId('anon_…')`) after registering trackers.
 *
 * When a customer is logged in, identity is owned by `useIdentifyCustomer`
 * (mounted at the root). On native, the init-time anon reset resolves AFTER
 * that hook has already identified the customer — clobbering it back to
 * anonymous. So we only set the anonymous identity when there is no logged-in
 * customer. The anonymousId is still stored for event enrichment either way.
 *
 * SQR-12581.
 */
export const shouldSetAnonymousIdentity = (
  customerId: string | undefined,
): boolean => !customerId;
